import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'

class EditAmount extends React.Component {
  constructor (props) {
    super (props)

    const {
      unique_number,
      discount_amount,
      total_deposit_amount,
      total_admin_fee,
      total_additional_price,
      total_amount
    } = props.detail

    this.state = {
      unique_number,
      discount_amount,
      total_deposit_amount,
      total_admin_fee,
      total_additional_price,
      total_amount
    }
  }

  _fieldChange = (event, field) => {
    let val = event.target.value
    let newState = { ...this.state }
    if (event.target.type === 'number') {
      val = parseFloat(val)
    }
    newState[field] = val
    this.setState(newState)
  }

  _checkField = (field) => {
    let val = this.state[field]
    let newState = { ...this.state }
    if (!val) {
      val = 0
      newState[field] = val
      this.setState(newState)
    }
  }

  _submit = (event) => {
    event.preventDefault()
    const form = {...this.state}
    const data = {
      id: this.props.detail.id,
      form
    }

    this.props.submit(data)
    this.props.closeModal()
  }

  render() {
    const { order, detail } = this.props

    const fields = [
      { name: 'unique_number', label: 'Unique Number' },
      { name: 'discount_amount', label: 'Discount Amount' },
      { name: 'total_deposit_amount', label: 'Total Deposit Amount' },
      { name: 'total_admin_fee', label: 'Total Admin Fee' },
      { name: 'total_additional_price', label: 'Total Additional Price' },
      { name: 'total_amount', label: 'Total Amount' },
    ]

    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '40vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Edit Amount <div className="badge badge-secondary ml-2">{detail.order_number}</div> 
            {(order.fetching || order.processing) && 
              <div className="badge badge-info ml-2">{order.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>

        {
          fields.map((field, i) => {
            return (
              <div key={i} className="form-group row">
                <div className="col-4">
                  <label className="control-label">{ field.label }</label>
                </div>
                <div className="col-8">
                  <input type="number" readOnly={field.name === 'total_amount'} min="0" step="any" className="form-control" value={ this.state[field.name] } onBlur={() => this._checkField(field.name)} onChange={(event) => this._fieldChange(event, field.name)}/>
                </div>
              </div>
            )
          })
        }

        <div className="text-right">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" className="btn btn-lg btn-primary">Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(OrderActions.orderUpdateAmountRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EditAmount)



// WEBPACK FOOTER //
// ./src/Containers/Order/EditAmount.js